import React from 'react'

export interface IWorkplaceResultsResourceItemLinkProps {
  url: string
  content: string
}
const WorkplaceResultsResourceItemLink = (
  props: IWorkplaceResultsResourceItemLinkProps
) => (
  <li>
    <a href={props.url} target="_blank" rel="noreferrer">
      {props.content}
    </a>
  </li>
)

export default WorkplaceResultsResourceItemLink
